<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'データと同期処理'">
          <list-item :spanText="'Q. '" :text="'1週間以上アプリを放置するとその前の歩数がなくなった'" :urlName="'Help32'"></list-item>
          <list-item :spanText="'Q. '" :text="'歩数がカウントされない(Android)'" :urlName="'Help24'"></list-item>
          <list-item :spanText="'Q. '" :text="'歩数が0のまま同期できない(Android)'" :urlName="'Help3'"></list-item>
          <list-item :spanText="'Q. '" :text="'一部の歩数が記録されない(Android)'" :urlName="'Help4'"></list-item>
          <list-item :spanText="'Q. '" :text="'歩数が0のまま同期できない(iPhone)'" :urlName="'Help2'"></list-item>
          <list-item :spanText="'Q. '" :text="'ホームを下スワイプしても同期しない'" :urlName="'Help25'"></list-item>
          <list-item :spanText="'Q. '" :text="'過去の計測データの確認方法は？'" :urlName="'Help13'"></list-item>
          <list-item :spanText="'Q. '" :text="'ホームの歩数がランキング画面と異なる原因'" :urlName="'Help14'"></list-item>
          <list-item :spanText="'Q. '" :text="'WeRUNの歩数がiPhoneヘルスケアと異なる原因'" :urlName="'Help10'"></list-item>
          <list-item :spanText="'Q. '" :text="'WeRUNのデータが他社製アプリと異なる理由'" :urlName="'Help5'"></list-item>
          <list-item :spanText="'Q. '" :text="'ネットがなくても歩数計測できますか？'" :urlName="'Help6'"></list-item>
          <list-item :spanText="'Q. '" :text="'歩数は激増しているまたは歩いても計測されない(Android)'" :urlName="'Help8'"></list-item>
          <list-item :spanText="'Q. '" :text="'計測データに関してご質問がある場合'" :urlName="'Help11'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory11.vue